let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fSOQ7")).then(() => parcelRequire('ki92G'));